import Vuex from 'vuex';
import Vue from 'vue';
import directMail from './modules/directMail';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production' || 'staging',
  modules: {
    directMail,
  },
});
